
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import gambleAwareLogoDark from "../../logos/begambleaware.svg";
import eighteenPlusLogoDark from "../../logos/18-plus.svg";
import gambleAwareLogoLight from "../../logos/begambleaware-b.png";
import eighteenPlusLogoLight from "../../logos/18-plus-b.png";
const Footer = ({ props }) => {
  // track theme in state
  const [isLightTheme, setIsLightTheme] = useState(
    () => document.documentElement.getAttribute("data-theme") === "light"
  );

  useEffect(() => {
    // helper to read the current attribute
    const checkTheme = () =>
      setIsLightTheme(
        document.documentElement.getAttribute("data-theme") === "light"
      );

    // watch for changes to data-theme on <html>
    const observer = new MutationObserver((mutations) => {
      for (let m of mutations) {
        if (m.attributeName === "data-theme") {
          checkTheme();
        }
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    // cleanup
    return () => observer.disconnect();
  }, []);

  const gambleAwareLogo = isLightTheme
    ? gambleAwareLogoLight
    : gambleAwareLogoDark;
  const eighteenPlusLogo = isLightTheme
    ? eighteenPlusLogoLight
    : eighteenPlusLogoDark;
  return (
    <footer className={`site-footer ${props.size === "sm" ? "sm" : "lg"}`}>
      {/* Top section with two columns */}
      <div className="footer-top">
        {/* Left Column: Links */}
        <div className="footer-left">
          <ul className="footer-links-list">
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/disclaimer">Disclaimer</Link>
            </li>
            <li>
              <Link to="/affiliate-disclosure">Affiliate Disclosure</Link>
            </li>
          </ul>
        </div>

        {/* Right Column: Gamble Aware */}
        <div className="footer-right">
          <p>
            You must be 18 years or older to place a bet in the UK. Please gamble responsibly.
          </p>
          <div className="footer-logos">
            <img src={eighteenPlusLogo} alt="18+ Logo" className="footer-logo" />
            <img src={gambleAwareLogo} alt="BeGambleAware" className="footer-logo" />
          </div>
        </div>
      </div>

      {/* Bottom section: Copyright */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} MatchedEdge. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
